import { IconMail, IconPhone } from '~/components'
import { twMerge } from '~/lib/utils'

import { CONTACT_INFO } from './contact-info'

type ContactMethodsProps = {
  /**
   * カード下部に表示する補足注記（先頭の「※」は自動付与）。
   * 例: 物件詳細ページで「『〇〇の件で』とお伝えください」を案内する。
   */
  note?: string
  className?: string
}

const cardClassName =
  'flex flex-1 flex-col gap-y-1 rounded-md border border-brand/40 bg-white p-4 ' +
  'transition-colors hover:border-brand hover:bg-brand-bg ' +
  'focus:outline-none focus:ring-2 focus:ring-brand focus:ring-offset-2'

/**
 * 電話・メールの問い合わせ導線ブロック（お問い合わせページ・物件詳細フォームで共用）。
 * 全社共通の窓口情報 {@link CONTACT_INFO} を tel: / mailto: リンクで提示する。
 */
export const ContactMethods = ({ note, className }: ContactMethodsProps) => {
  return (
    <section
      aria-label="電話・メールでのお問い合わせ"
      className={twMerge(
        'flex flex-col gap-y-3 rounded-lg border border-brand bg-brand-bg p-4 md:p-5',
        className,
      )}
    >
      <h2 className="text-sm font-bold text-textPrimary md:text-base">
        お電話・メールでもお問い合わせいただけます
      </h2>

      <div className="flex flex-col gap-3 md:flex-row">
        <a className={cardClassName} href={CONTACT_INFO.phoneHref}>
          <span className="flex items-center gap-x-1.5 text-sm font-medium text-brand">
            <IconPhone className="h-4 w-4" />
            お電話
          </span>
          <span className="text-xl font-bold leading-tight text-textPrimary md:text-2xl">
            {CONTACT_INFO.phone}
          </span>
          <span className="text-xs text-grayText">{CONTACT_INFO.hours}</span>
        </a>

        <a className={cardClassName} href={CONTACT_INFO.emailHref}>
          <span className="flex items-center gap-x-1.5 text-sm font-medium text-brand">
            <IconMail className="h-4 w-4" />
            メール
          </span>
          <span className="break-all text-base font-bold leading-tight text-textPrimary md:text-lg">
            {CONTACT_INFO.email}
          </span>
        </a>
      </div>

      {note && <p className="text-xs text-textPrimary">※ {note}</p>}
    </section>
  )
}
